export type NdtExitPath = '/dashboard' | '/ndt-selection' | '/loft-selection'

const NDT_EXIT_KEY = 'ndtExitPath'
const EXIT_PATHS: readonly NdtExitPath[] = ['/dashboard', '/ndt-selection', '/loft-selection']

export function setNdtExitPath(path: NdtExitPath) {
  sessionStorage.setItem(NDT_EXIT_KEY, path)
}

export function getNdtExitPath(): NdtExitPath {
  const stored = sessionStorage.getItem(NDT_EXIT_KEY) as NdtExitPath | null
  return stored && EXIT_PATHS.includes(stored) ? stored : '/ndt-selection'
}

export function ndtFormPath(iconName: string): string | null {
  switch (iconName) {
    case 'ET':
      return '/et-test'
    case 'MPI':
      return '/mt-test'
    case 'VT':
      return '/vt-test'
    case 'PT':
      return '/pt-test'
    case 'LT':
      return '/lt-test'
    case 'UT':
      return '/ut-test'
    case 'RT':
      return '/rt-test'
    case 'Thread':
      return '/thread-test'
    case 'SR':
      return '/service-report'
    default:
      return null
  }
}
